import Script from "next/script";
import { TemplateFAQSchemaType } from "src/server/zsl/templates/types";

interface FAQSchemaProps {
  questions: TemplateFAQSchemaType[] | null;
}

export const FAQSchema = ({ questions }: FAQSchemaProps) => {
  if (!questions) return null;

  const FAQJson = {
    __html: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: questions.map((question) => ({
        "@type": "Question",
        name: question.name,
        acceptedAnswer: {
          "@type": "Answer",
          text: question.content,
        },
      })),
    }),
  };

  return (
    <Script
      type="application/ld+json"
      dangerouslySetInnerHTML={FAQJson}
      key="template-faq-jsonld"
    />
  );
};
